import { AuthorizationProvider } from '@frontend/authorization';
import { ObjectBadgeOverrideProvider } from '@frontend/components/badge';
import { ModalProvider } from '@frontend/modal';
import { AccountStoreProvider, BlobStoreProvider, BrandingStoreProvider, DocumentStoreProvider, LicenseStoreProvider } from '@frontend/repository';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { Authentication } from './authentication/basic-authentication-wrapper/authentication.component';
import { AdminObjectBadge } from './components/admin-object-badge/admin-object-badge.component';
import { DevIndicator } from './dev-indicator';
import NoAccountMessage from './no-account-message';
import { useAppDispatch } from './redux/store';
import Resolver from './utils/resolver';

export const DefaultProviders = (props: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    return (
        <>
            <DocumentStoreProvider>
                <BlobStoreProvider>
                    <BrandingStoreProvider>
                        <BrowserRouter>
                            <Authentication>
                                <AccountStoreProvider noAccountsMessage={<NoAccountMessage />}>
                                    <AuthorizationProvider dispatch={dispatch}>
                                        <LicenseStoreProvider disabled>
                                            <Resolver>
                                                <ModalProvider>
                                                    <ObjectBadgeOverrideProvider
                                                        override={(badgeProps) => (
                                                            <AdminObjectBadge
                                                                id={badgeProps.id}
                                                                entityType={badgeProps.entityType}
                                                                display={badgeProps.display}
                                                                className={badgeProps.className}
                                                                disableClick={badgeProps.disableClick}
                                                                hideIcon={badgeProps.hideIcon}
                                                                clearable={badgeProps.clearable}
                                                                overwriteDisplayMap={badgeProps.overwriteDisplayMap}
                                                                styles={badgeProps.styles}
                                                            />
                                                        )}>
                                                        {props.children}
                                                    </ObjectBadgeOverrideProvider>
                                                </ModalProvider>
                                            </Resolver>
                                        </LicenseStoreProvider>
                                    </AuthorizationProvider>
                                </AccountStoreProvider>
                            </Authentication>
                        </BrowserRouter>
                        <ToastContainer />
                    </BrandingStoreProvider>
                </BlobStoreProvider>
            </DocumentStoreProvider>
            <DevIndicator />
        </>
    );
};

export default DefaultProviders;
